import { createContext, useContext } from "react";
import { Platform as RNPlatform } from "react-native";

import type { Platform } from "./types";

/** The app's two targets. Anything that is not the web is treated as Android (no iOS build). */
export const devicePlatform: Platform =
  RNPlatform.OS === "web" ? "web" : "android";

const PlatformContext = createContext<Platform>(devicePlatform);

/** Tests use it to check both targets' guards from one Jest project. The app never overrides it. */
export const PlatformProvider = PlatformContext.Provider;

export function usePlatform(): Platform {
  return useContext(PlatformContext);
}
